import React, { useRef } from "react";
import { Table, Input } from "reactstrap";
import { IDataTableProps } from "../../../interfaces/Index";
import "./DataTable.scss";
import placeHolder from "../../../assets/product_placeholder_image.png";

const placeHolderImage = placeHolder;

export const addStatusClasses = (e: any): any => {
  let dataJson: string = String(e);
  if (dataJson.includes("OPEN") || dataJson === "ACTIVE") {
    return "open-status";
  } else if (dataJson.includes("CANCELLED") || dataJson === "ERROR") {
    return "cancelled-status";
  } else if (dataJson.includes("CLOSED")) {
    return "closed-status";
  } else if (dataJson.includes("REATTEMPT") || dataJson === "PENDING") {
    return "reattempt-status";
  } else {
    return "invalid-status";
  }
};

export const addStatus = (e: any): any => {
  let dataJson: string = e;
  if (dataJson) {
    return "-";
  }
  return "disabled";
};

export const parentIDFunc = (id: any, toggleClass: any) => {
  if (id === null) {
    toggleClass.current = !toggleClass.current;
  }
  return toggleClass.current ? "with-sub-category" : "without-sub-category";
};

export const generateBodyRowClassName = (
  tableId: string,
  id: any,
  toggleClass: any,
  itemData: any
) => {
  let classes = parentIDFunc(id, toggleClass);

  if (tableId === "product-list") {
    // Check item stock and add disable class if stock is out
    classes += " out-of-stock-product";
  }
  return `${classes}`;
};

export const checkDisabled = (tableId: string, data: any) => {
  if (tableId === "product-list") {
    // Check item stock and add disable class if stock is out
    return true;
  }
  return false;
};

export const renderTableText = (tableId: string, data: any, dataType: any) => {
  if (tableId === "product-list" && dataType.key === "itemPrice") {
    // Check item stock and add disable class if stock is out
    return "Item not available";
  } else {
    const dataValue =
      data[dataType.key] && data[dataType.key] === 0
        ? 0
        : data[dataType.key] !== undefined
        ? data[dataType.key]
        : "";

    return `${dataType.prepend || ""} ${dataValue}`;
  }
};

const DataTable: React.FunctionComponent<IDataTableProps> = (
  props: IDataTableProps
) => {
  let toggleClass: any = useRef(true);

  const renderTableHeaders = () => {
    const { handleAllRecordSelection, tableHeaderData, allRecordsChecked } =
      props;
    return tableHeaderData?.map((header, index) => {
      if (header.type === "checkbox") {
        return (
          <th key={index}>
            <Input
              type={header.type}
              checked={allRecordsChecked}
              onClick={handleAllRecordSelection}
            />
          </th>
        );
      }
      return <th key={index}>{header.text}</th>;
    });
  };

  const renderItemTags = (data: any) => {
    return data.map((item: string, i: number) => {
      return <span className="item-tag-text">{item}</span>;
    });
  };

  const renderTableData = (data: any, index: number) => {
    const { tableBodyDataTypes, checkBoxClickHandler, tableId } = props;
    return tableBodyDataTypes.map((dataType, i) => {
      if (dataType.type === "checkbox") {
        return (
          <td key={i}>
            <Input
              key={index}
              type={dataType.type}
              checked={data[dataType.key]}
              onClick={(e) => checkBoxClickHandler?.(e, index)}
              // disabled={checkDisabled(tableId as string, data)}
            />
          </td>
        );
      } else if (dataType.type === "img") {
        return (
          <td key={i}>
            {props.tableId === "category-list" ? (
              data["categoryType"] === "core" && (
                <img
                  src={data[dataType.key] || placeHolderImage}
                  alt={dataType.imgAltTag || "placeholder"}
                />
              )
            ) : (
              <img
                src={data[dataType.key] || placeHolderImage}
                alt={dataType.imgAltTag || "placeholder"}
              />
            )}
          </td>
        );
      } else if (dataType.type === "Array") {
        // Can be used for displaying tags
        return (
          <td key={index} className="item-tags">
            {renderItemTags(data[dataType.key])}
          </td>
        );
      } else if (
        // dataType.key === "orderStatus" ||
        dataType.key === "promoStatus" ||
        dataType.key === "campaignStatus" ||
        dataType.key === "status" ||
        dataType.key === "enabled"
      ) {
        return (
          <td key={i} className="order-status">
            <span className={addStatusClasses(data[dataType.key])}>
              {data[dataType.key]}
            </span>
          </td>
        );
      } else if (dataType.key === "orderStatus") {
        return (
          <td key={i} className="order-status">
            <span className={addStatusClasses(data[dataType.key])}>
              {data[dataType.key]}
            </span>
            {typeof data["isLocked"] !== "undefined" && data["isLocked"] ? (
              <span className="closed-status status-margin-left">LOCKED</span>
            ) : (
              <span></span>
            )}
          </td>
        );
      } else if (dataType.key === "isEnabled") {
        return (
          <td key={i} className="status">
            <span className={addStatus(data[dataType.key])}>
              {addStatus(data[dataType.key])}
            </span>
          </td>
        );
      }
      return (
        <td
          key={i}
          title={data[dataType.key]}
          // className={"disable-product-out-of-stock"}
        >
          {/* {renderTableText(tableId as string, data, dataType)} */}
          {dataType.prepend}
          {data[dataType.key]}
        </td>
      );
    });
  };

  const renderTableBody = () => {
    const { editRowHandler, tableBodyRowData, tableBodyDataTypes, tableId } =
      props;
    return tableBodyRowData.map((item, index) => {
      return (
        // <tr
        //   key={index}
        //   className={item.isChecked ? "record-selected" : ""}
        //   onClick={() => editRowHandler?.(index)}
        // >
        //   {tableBodyDataTypes &&
        //     tableBodyDataTypes.length > 0 &&
        //     renderTableData(item, index)}
        // </tr>

        <tr
          key={index}
          // className={
          //   generateBodyRowClassName(
          //     tableId as string,
          //     item.parentId,
          //     toggleClass,
          //     item
          //   ) || (item.isChecked ? "record-selected" : "")
          // }
          className={
            parentIDFunc(item.parentId, toggleClass) ||
            (item.isChecked ? "record-selected" : "")
          }
          onClick={(e) => editRowHandler?.(e, index)}
        >
          {tableBodyDataTypes &&
            tableBodyDataTypes.length > 0 &&
            renderTableData(item, index)}
          {/* {item["categoryType"] === "core" && <div>core</div>}
          {item["categoryType"] === "sub_category" && <div>sub_category</div>} */}
        </tr>
      );
    });
  };

  const renderTableFooter = () => {
    const { tableFooterData, noSearchResultFlag, tableBodyRowData } = props;
    return (
      noSearchResultFlag &&
      tableBodyRowData &&
      tableBodyRowData.length === 0 && (
        <tr>
          <div className="no-search-found">
            <img src={tableFooterData?.imgSrc} alt={tableFooterData?.imgAlt} />
            <div className="no-search-title">{tableFooterData?.title}</div>
            <div className="no-search-sub-title">
              {tableFooterData?.subTtitle}
            </div>
          </div>
        </tr>
      )
    );
  };

  return (
    <Table borderless striped className="table" id={props.tableId}>
      {props.tableHeaderData && props.tableHeaderData.length > 0 && (
        <thead>
          <tr>{renderTableHeaders()}</tr>
        </thead>
      )}
      <tbody>
        {props.tableBodyRowData &&
          props.tableBodyRowData.length > 0 &&
          renderTableBody()}
      </tbody>
      {props.tableFooterData && (
        <tfoot>
          <tr>{renderTableFooter()}</tr>
        </tfoot>
      )}
    </Table>
  );
};

DataTable.defaultProps = {
  tableId: "tableId",
  tableHeaderData: null,
  tableFooterData: null,
  noSearchResultFlag: false,
  allRecordsChecked: false,
};

export default DataTable;
